import { Schedule, ScheduleResponse } from "models/Schedule"

export function formatScheduleResponse(schedules: ScheduleResponse[]): Schedule[] {
  if (!schedules) return []

  return schedules?.map(schedule => ({
    id: schedule.id,
    session: schedule.session,
    startDate: new Date(schedule.start_date),
    endDate: new Date(schedule.end_date),
    statusCode: schedule.status_code,
    statusName: schedule.status_name,
    virtualRoomHash: schedule.virtual_room_hash,
    medicalReturn: schedule.medical_return,
    agendaEventId: schedule.agenda_event_id,
    tokenHasBeenFilled: schedule.token_has_been_filled,
    virtualRoomAvailable: schedule.virtual_room_available,
    consultationEvaluation: schedule.consultation_evaluation,
    cancellationEnabled: schedule.cancellation_enabled,
    rescheduleEnabled: schedule.reschedule_enabled,
    guests: schedule.guests.map(guest => ({
      id: guest.id,
      personProfile: {
        person: {
          username: guest.person_profile.person.username,
        },
        profileCode: guest.person_profile.profile_code,
        profileName: guest.person_profile.profile_name,
      },
    })),
  }))
}